import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useUserList = () => {
  const [loading, setLoading] = useState(true);
  const [userList, setUserList] = useState([]);
  const [pageRef, setPageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getUserList = (params = {}) => {
    setLoading(true);

    axiosClient
      .get('SettingAccount/User/List', { params })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);

          setUserList(prev => {
            const orderedList = res.data.value.list.map(element => ({
              ...element,
              id: element.guid,
            }));

            return { ...prev, [params?.Page || 1]: orderedList };
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getUserList, loading, userList, pageRef];
};

export default useUserList;
